<template>
    <!-- Intentionally empty. Rendering lives on UserBubble.vue, which
         consumes the tags via a parent-computed prop. This component exists
         only so the tool_ui_registry has an entry for `people_tags` and
         ToolResultRow doesn't fall through to its debug-JSON view. The
         hidden span keeps the Vue template-root rule happy without taking
         any visual space. Nadia2Chat.vue also short-circuits the row via
         INLINE_UI_KINDS, so this template should never actually render. -->
    <span class="hidden" />
</template>

<script setup lang="ts"></script>
